"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var IBAN = _interopRequireWildcard(require("iban-ts"));

var _utils = require("./utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var InputIBAN = /*#__PURE__*/function (_React$Component) {
  _inherits(InputIBAN, _React$Component);

  function InputIBAN(props) {
    var _this;

    _classCallCheck(this, InputIBAN);

    _this = _possibleConstructorReturn(this, (InputIBAN.__proto__ || Object.getPrototypeOf(InputIBAN)).call(this, props));
    _this.state = {
      iban: '',
      error: {}
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(InputIBAN, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState(function (prev) {
        var iban = _this2.props.value;

        if (iban) {
          iban = IBAN.printFormat(iban);
        }

        prev.iban = iban;
        return prev;
      });
      this.testIBAN(this.props.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.props.value !== prevProps.value && this.state.iban === '') {
        this.setState(function (state) {
          state.iban = _this3.props.value;
          return state;
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var error = this.state.error[this.props.name] ? this.state.error : this.props.errors;
      var label = this.props.label || (0, _utils.capitalizeFirstLetter)(props.name),
          placeholder = "".concat(props.t('Enter a value for'), ": ").concat(label),
          hasError = error[props.name],
          errorMsg = '';

      if (hasError) {
        errorMsg = error[props.name].map(function (errorMsg) {
          return props.t(errorMsg);
        }).join(', ');
      }

      return /*#__PURE__*/_react.default.createElement("label", {
        className: ['input', hasError ? 'error' : '', props.readOnly ? 'read-only' : ''].join(' ')
      }, label, /*#__PURE__*/_react.default.createElement("span", {
        className: "input__wrapper"
      }, /*#__PURE__*/_react.default.createElement("input", {
        type: props.type,
        name: props.name,
        value: this.state.iban,
        placeholder: placeholder,
        readOnly: props.readOnly,
        onBlur: props.onBlur ? props.onBlur : void 0,
        onChange: this.handleChange,
        disabled: props.disabled
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "input__error"
      }, errorMsg));
    }
    /**
     *
     * @param iban
     */

  }, {
    key: "testIBAN",
    value: function testIBAN(iban) {
      if (!iban || IBAN.isValid(iban)) {
        this.setState(function (state) {
          state.error = {};
        });
      } else {
        this.setState(function (state, props) {
          state.error[props.name] = ['iban-invalid'];
        });
      }
    }
    /**
     *
     * @param e
     * @param name - field data löschen
     */

  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var value = e.target.value;
      this.setState(function (prev) {
        prev.iban = IBAN.printFormat(value);
        return prev;
      });
      this.testIBAN(value);
      this.props.onChange(e, this.props.name, value);
    }
  }]);

  return InputIBAN;
}(_react.default.Component);

InputIBAN.propTypes = {
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func.isRequired,
  disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  id: _propTypes.default.any,
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  required: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
  type: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.bool]),
  optional: _propTypes.default.bool,
  infoText: _propTypes.default.string,
  errors: _propTypes.default.object,
  t: _propTypes.default.func
};
InputIBAN.defaultProps = {
  type: 'text',
  optional: false,
  infoText: null
};
var _default = InputIBAN;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/input-iban.js
// module id = 545
// module chunks = 0